import { error, finish } from '../../../modules/grades/actions/update';
import { Amount } from 'src_common/common/amount/Amount';
import { request as getGradesListAction } from 'src/modules/grades/actions/get-list';

function buildOldValue(value) {
    if (value === null) {
        return null;
    }

    if (value === undefined) {
        return undefined;
    }

    return $appState.configState.precision.valueOldFormat(new Amount(value));
}


function buildValue(value) {
    if (value === null) {
        return null;
    }
    if (value === undefined) {
        return undefined;
    }

    return $appState.configState.precision.newFromOld(value).value;
}

export function request(dispatch, { id, sportId, data }) {
    const marketLimits = {};
    for (const marketLimitsKey in data.marketLimits) {
        marketLimits[marketLimitsKey] = {
            betLimits: {
                liabilityLimit: buildOldValue(data.marketLimits[marketLimitsKey].betLimits.liabilityLimit),
                maxBet: buildOldValue(data.marketLimits[marketLimitsKey].betLimits.maxBet),
                maxMultipleBet: buildOldValue(data.marketLimits[marketLimitsKey].betLimits.maxMultipleBet),
                maxWin: buildOldValue(data.marketLimits[marketLimitsKey].betLimits.maxWin)
            },
            matchingMarkets: data.marketLimits[marketLimitsKey].matchingMarkets
        };
    }
    data.marketLimits = marketLimits;

    $appState.sdkStaff.updateSportGrade({
        sport_id: sportId,
        grade_id: id,
        requestBody: { marketLimits: data.marketLimits, name: data.name, displayName: data.displayName}
    }).then(
        () => {
            dispatch(getGradesListAction(sportId));

            // grade.defaultLimits = {
            //     liabilityLimit: buildValue(grade.defaultLimits.liabilityLimit),
            //     maxBet: buildValue(grade.defaultLimits.maxBet),
            //     maxMultipleBet: buildValue(grade.defaultLimits.maxMultipleBet),
            //     maxWin: buildValue(grade.defaultLimits.maxWin)
            // };

            // const marketLimits = {};
            // for (const marketLimitsKey in grade.marketLimits) {
            //     marketLimits[marketLimitsKey] = {
            //         liabilityLimit: buildValue(grade.marketLimits[marketLimitsKey].liabilityLimit),
            //         maxBet: buildValue(grade.marketLimits[marketLimitsKey].maxBet),
            //         maxMultipleBet: buildValue(grade.marketLimits[marketLimitsKey].maxMultipleBet),
            //         maxWin: buildValue(grade.marketLimits[marketLimitsKey].maxWin)
            //     };
            // }

            // grade.marketLimits = marketLimits;
            // return dispatch(finish(id, grade));
        }
    ).catch(
        errors => dispatch(error(id, errors))
    );
}
